import { buildConnection } from '$app/arrp-hub-connection-builder'
import apiConnection from '$app/plugins/api-connection'
import defaultPagingInfo from '$app/default-paging-info'

const connection = buildConnection('StagingFlkrs');

// STATE
const state = {
  loading: false,
  nextId: 0,
  pagingInfo: defaultPagingInfo(),
  items: [],
  locks: [],
  totalItems: 0,
  searchModel: {
    districtCode: '',
    lastname: '',
    firstName: '',
    reduceToErrors: false,
    reduceToWarnings: false
  }
}

// MUTATIONS
const mutations = {
  updateSearchModel(state, searchModel) {
    state.searchModel = searchModel;
    state.pagingInfo.page = 1;
  },
  updateTotalItems(state, totalItems) {
    state.totalItems = totalItems;
  },
  addItem(state, item) {
    state.items.push(item);
    state.nextId = item.id + 1;
  },
  updateItem(state, item) {
    const idx = state.items.findIndex(x => x.stagingFlkrsid === item.stagingFlkrsid);
    if (idx !== -1) {
      state.items.splice(idx, 1, { ...item });
    }
  },
  setLocks(state, locks) {
    state.locks = locks;
  },
  updateItems(state, items) {
    state.items = [...items];
  },
  updatePagingInfo(state, pagingInfo) {
    state.pagingInfo = { ...pagingInfo };
  },
  setLoading(state, loading) {
    state.loading = loading;
  }
}

// ACTIONS
const actions = ({
  async connect({ commit, dispatch }) {
    connection.onLocksUpdated((locks) => commit('setLocks', locks));
    connection.onEntitiesUpdated(() => dispatch('search'));
    await connection.connect();
  },
  async disconnect() {
    await connection.disconnect();
  },
  lockItem({ commit }, item) {
    connection.lockById(item.stagingFlkrsid);
  },
  unlockItem({ commit }, item) {
    connection.unlockById(item.stagingFlkrsid);
  },
  search({ commit, state }) {
    const searchModel = { ...state.searchModel, pagingInfo: state.pagingInfo };
    commit('setLoading', true);
    apiConnection.post('api/arrp/searchstagedflkrs', searchModel).then(resp => {
      const items = resp.data.items.map(e => ({ ...e, errors: e.rowErrors, warnings: e.rowWarnings }));

      commit('updateItems', items);
      commit('updateTotalItems', resp.data.totalItems);
    }).finally(() => commit('setLoading', false));
  },
  itemAdded({ dispatch }, item) {
    apiConnection.post('api/arrp/saveStagedFlkrs', { ...item }).then(resp => {
      dispatch('search');
    });
  },
  itemEdited({ dispatch }, item) {
    apiConnection.post('api/arrp/saveStagedFlkrs', { ...item }).then(resp => {
      dispatch('search');
    });
  },
  deleteItem({ dispatch }, item) {
    var id = item.stagingFlkrsid;
    apiConnection.delete('api/arrp/deleteStagedFlkrs?stagingFlkrsId=' + id);
    dispatch('search');
  },
  sortItems({ commit, dispatch }, sortValues) {
    const pInfo = { ...state.pagingInfo, page: 1, ...sortValues };
    commit('updatePagingInfo', pInfo);
    dispatch('search');
  },
  pagingInfoUpdated({ commit, dispatch }, pagingInfo) {
    commit('updatePagingInfo', pagingInfo);
    dispatch('search');
  },
  getPagedData({ commit, dispatch, state }, page) {
    commit('updatePagingInfo', { ...state.pagingInfo, page });
    dispatch('search');
  }
});

// GETTERS
const getters = {
  searchModel: state => state.searchModel,
  itemsToLinkToEnrollment: state => state.itemsToLinkToEnrollment,
  currentPage: state => state.items.map(item => ({ ...item, locked: state.locks.includes(item.stagingFlkrsid) }))
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
